import React, { createContext, useContext, useEffect, useState } from 'react';
import type { PricingMarket } from '../types';

const STORAGE_KEY = 'becoder_pricing_market';

interface PricingMarketContextType {
  market: PricingMarket;
  setMarket: (market: PricingMarket) => void;
}

const PricingMarketContext = createContext<PricingMarketContextType | undefined>(undefined);

function readStoredMarket(): PricingMarket {
  try {
    const saved = localStorage.getItem(STORAGE_KEY);
    if (saved === 'international' || saved === 'iraq') return saved;
  } catch {
    /* ignore */
  }
  return 'iraq';
}

export const PricingMarketProvider: React.FC<{ children: React.ReactNode }> = ({ children }) => {
  const [market, setMarketState] = useState<PricingMarket>(readStoredMarket);

  useEffect(() => {
    try {
      localStorage.setItem(STORAGE_KEY, market);
    } catch {
      /* ignore */
    }
  }, [market]);

  const setMarket = (next: PricingMarket) => {
    if (next !== 'iraq' && next !== 'international') return;
    setMarketState(next);
  };

  return (
    <PricingMarketContext.Provider value={{ market, setMarket }}>
      {children}
    </PricingMarketContext.Provider>
  );
};

export const usePricingMarket = () => {
  const context = useContext(PricingMarketContext);
  if (!context) throw new Error('usePricingMarket must be used within a PricingMarketProvider');
  return context;
};
